/**
 * Profile & Org Data Corrections API Service
 */
import apiClient from '../lib/apiClient';

/** Get full org profile: CRA source data + any corrections + effective values */
export const getOrgProfile = async (bn) => {
  const { data } = await apiClient.get(`/orgs/${bn}/profile`);
  return data;
};

/**
 * Save one or more field corrections.
 * @param {string} bn - Business Number
 * @param {Object} corrections - { field_key: { value, note } }
 */
export const updateOrgProfile = async (bn, corrections) => {
  const { data } = await apiClient.patch(`/orgs/${bn}/profile`, corrections);
  return data;
};

/** Remove a single field correction (reverts to CRA data) */
export const deleteOverride = async (bn, fieldKey) => {
  await apiClient.delete(`/orgs/${bn}/overrides/${fieldKey}`);
};

/** List all active overrides for an org (admin / audit) */
export const listOverrides = async (bn) => {
  const { data } = await apiClient.get(`/orgs/${bn}/overrides`);
  return data;
};

export const getOrgPositioning = async (bn) => {
  const response = await apiClient.get(`/orgs/${bn}/positioning`);
  return response.data;
};

export const updateOrgPositioning = async (bn, data) => {
  const response = await apiClient.put(`/orgs/${bn}/positioning`, data);
  return response.data;
};
